var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNginx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 120,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.145 41.059V21.4892C5.12628 21.1447 5.20775 20.8023 5.3791 20.5053C5.55045 20.2083 5.80396 19.9702 6.1075 19.821L39.04 0.325534C39.6325 -0.0537161 40.2975 -0.130593 40.89 0.248657L73.97 19.8185C74.2535 19.9857 74.4865 20.23 74.6431 20.5244C74.7997 20.8188 74.8739 21.1518 74.8575 21.4867V60.552C74.8739 60.8869 74.7997 61.2199 74.6431 61.5142C74.4865 61.8086 74.2535 62.0529 73.97 62.2201L45.5525 79.0558C44.0636 79.9692 42.5583 80.8542 41.0375 81.7105C40.3725 82.0898 39.705 82.0898 39.0375 81.7105L6.03249 62.215C5.43999 61.8358 5.145 61.3797 5.145 60.6212V41.0513V41.059Z",
    fill: "#009438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.455 33.7737V56.58C28.455 59.1579 26.455 61.4334 23.7925 61.3591C22.1675 61.2822 20.9075 60.6006 20.0425 59.1604C19.5975 58.4788 19.45 57.7203 19.45 56.8849V25.2047C19.45 23.0779 20.7075 21.566 22.335 20.8818C23.9625 20.1976 25.59 20.3514 27.22 20.8818C28.775 21.3379 29.9575 22.3219 30.97 23.5366L50.655 47.7342C50.73 47.8111 50.805 47.9649 50.95 48.1135V25.051C50.95 22.6243 52.575 20.728 54.875 20.5C57.76 20.1207 59.685 22.2425 59.98 24.4462V56.7337C59.98 58.5275 59.165 59.8446 57.685 60.68C56.575 61.2873 55.39 61.4385 54.135 61.3616C52.3197 61.2378 50.5984 60.4893 49.25 59.2373C48.51 58.5557 47.9925 57.7203 47.325 56.9618L28.6 33.9762C28.6 33.8993 28.525 33.8224 28.45 33.7455L28.455 33.7737Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 82,
    rx: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/nginx.8902e6dd66fd42dd683a8341fabc3e28.svg";
export { ForwardRef as ReactComponent };